import dayjs from "dayjs";
import _ from "lodash";
import { v4 as uuid } from "uuid";

export const getMaxDuration = ({ playlist }) => {
  const result = _.chain(playlist)
    .map((item) => {
      const filteredAdsBlocks = _.filter(_.get(item, "adsBlocks"), (block) => {
        const blockMedias = _.get(block, "blockMedias");
        return _.size(blockMedias) > 0;
      });

      return { ...item, adsBlocks: filteredAdsBlocks };
    })
    .filter((item) => {
      const adsBlocks = _.get(item, ["adsBlocks"]);
      return _.size(adsBlocks) > 0;
    })
    .map((campaign) => {
      console.log("campaign :>> ", campaign);
      const adsBlocks = _.get(campaign, ["adsBlocks"]);
      const maxDuration = _.chain(campaign)
        .get(["adsBlocks"])
        .map((item) => {
          const blockMedias = _.get(item, ["blockMedias"]);
          return _.sumBy(blockMedias, "duration");
        })
        .max()
        .value();
      return {
        ...campaign,
        max_duration: maxDuration,
      };
    })
    .value();
  return result;
};

export const preprocessCampaigns = ({ playlist }) => {
  console.log("playlist :>> ", playlist);
  let processedData = [];
  let maxAdsBlocks = _.max(_.map(playlist, (c) => c.adsBlocks.length));

  for (let blockIndex = 0; blockIndex < maxAdsBlocks; blockIndex++) {
    let blockData = { blockIndex, contents: [] };

    playlist.forEach((campaign) => {
      const adsBlock = campaign.adsBlocks[blockIndex];
      const campaignMaxDuration = campaign.max_duration;

      // ✅ ข้าม campaign ที่ไม่มี adsBlock ใน block นี้
      if (!adsBlock || adsBlock.blockMedias.length === 0) return;

      let usedDuration = 0;
      let mediaIndex = 0;
      const mediaCount = adsBlock.blockMedias.length;

      while (usedDuration < campaignMaxDuration) {
        const media = adsBlock.blockMedias[mediaIndex];
        const remainingTime = campaignMaxDuration - usedDuration;
        const duration = Math.min(media.duration, remainingTime);

        blockData.contents.push({
          campaignId: campaign?.id,
          mediaId: media?.media_id,
          nanoId: uuid(),
          mediaName: media?.media?.display_name,
          campaignName: campaign.name,
          startTime: campaign.start_time,
          endTime: campaign.end_time,
          campaignMaxDuration,
          type: media.type,
          duration,
          attribute: media.attribute,
        });

        usedDuration += duration;
        mediaIndex = (mediaIndex + 1) % mediaCount;
      }
    });

    // ✅ เพิ่มเฉพาะ block ที่มี content จริง
    if (blockData.contents.length > 0) {
      processedData.push(blockData);
    }
  }

  return processedData;
};

export const generateTimeSlots = ({
  processedCampaigns,
  startTime,
  endTime,
}) => {
  const date = dayjs().format("YYYY-MM-DD");
  const slotStart = dayjs(`${date} ${startTime}`);
  const slotEnd = dayjs(`${date} ${endTime}`);

  let timeSlots = [];

  processedCampaigns.forEach((block) => {
    let blockData = { blockIndex: block.blockIndex, timeSlot: [] };
    let currentTime = slotStart;
    let contentIndex = 0;

    while (currentTime.isBefore(slotEnd)) {
      let hasValidContent = false;

      // ลูป content ทั้งหมดเพื่อหาอันที่แสดงผลได้ ณ currentTime
      for (let i = 0; i < block.contents.length; i++) {
        const content = block.contents[contentIndex];
        const contentStartTime = dayjs(`${date} ${content.startTime}`);
        const contentEndTime = dayjs(`${date} ${content.endTime}`);
        const nanoId = uuid();

        // ถ้า currentTime อยู่ในช่วงเวลาที่ content นี้เล่นได้
        if (
          !currentTime.isBefore(contentStartTime) &&
          !currentTime.isAfter(contentEndTime)
        ) {
          let duration = content.duration;
          let nextTime = currentTime.add(duration, "second");

          if (nextTime.isAfter(slotEnd)) {
            duration = slotEnd.diff(currentTime, "second");
            nextTime = slotEnd;
          }

          if (nextTime.isAfter(contentEndTime)) {
            duration = contentEndTime.diff(currentTime, "second");
            nextTime = contentEndTime;
          }

          if (duration <= 0) {
            contentIndex = (contentIndex + 1) % block.contents.length;
            break;
          }

          blockData.timeSlot.push({
            campaignId: content?.campaignId,
            mediaId: content?.mediaId,
            nanoId,
            mediaName: content.mediaName,
            campaignName: content.campaignName,
            startTime: currentTime.format("HH:mm:ss"),
            endTime: nextTime.format("HH:mm:ss"),
            type: content.type,
            duration,
            attribute: content.attribute,
          });

          currentTime = nextTime;
          contentIndex = (contentIndex + 1) % block.contents.length;
          hasValidContent = true;
          break;
        }

        // ถ้าเล่นไม่ได้ ลอง content ถัดไป
        contentIndex = (contentIndex + 1) % block.contents.length;
      }

      // ถ้าไม่มี content ไหนแสดงผลได้เลยใน currentTime → generate slot 'nothing'
      if (!hasValidContent) {
        // หา content ตัวถัดไปที่เริ่มเล่นได้
        let nextAvailableStart = slotEnd;
        for (const c of block.contents) {
          const s = dayjs(`${date} ${c.startTime}`);
          if (s.isAfter(currentTime) && s.isBefore(nextAvailableStart)) {
            nextAvailableStart = s;
          }
        }

        const gapEndTime = nextAvailableStart.isAfter(slotEnd)
          ? slotEnd
          : nextAvailableStart;

        const duration = gapEndTime.diff(currentTime, "second");

        if (duration > 0) {
          blockData.timeSlot.push({
            mediaId: null,
            nanoId: uuid(),
            campaignName: null,
            startTime: currentTime.format("HH:mm:ss"),
            endTime: gapEndTime.format("HH:mm:ss"),
            type: "nothing",
            duration,
            attribute: null,
          });

          currentTime = gapEndTime;
        } else {
          break;
        }
      }
    }

    timeSlots.push(blockData);
  });

  return timeSlots;
};

export const formatDuration = (totalSec) => {
  const hours = Math.floor(totalSec / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;

  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

  return parts.join(" ");
};

export const summarizeTimeSlots = ({ list }) => {
  const allSlots = _.flatMap(list, "timeSlot");
  const grouped = _.groupBy(allSlots, "mediaName");
  return _.map(grouped, (items, fileName) => {
    const totalDuration = _.sumBy(items, "duration");
    return {
      fileName,
      times: items.length,
      totalDuration: formatDuration(totalDuration),
    };
  });
};
